import { ModuleType } from '~/types/menu'

export default defineNuxtRouteMiddleware((to) => {
  const token = useCookie('token')
  const { moduleId } = useRouterStore()

  const publicPages = [
    'signout',
    'system',
    'clinux',
    'portal',
    'medico',
    'otrs',
    'resultado',
    'questionario',
    'azure-test',
    'azure-callback'
  ]

  // Se tem token e está tentando acessar a tela de login → ir para home
  if (token.value && to?.name === 'system') {
    return navigateTo('/')
  }

  // Páginas públicas ou sem nome → liberar
  if (publicPages.includes(to?.name as string) || !to?.name) {
    return
  }

  // Sem token → signout
  if (!token.value) {
    return navigateTo('/signout')
  }

  // Portal e Resultados: somente páginas /portal/*
  if (moduleId === ModuleType.PORTAL || moduleId === ModuleType.RESULTADO || moduleId === ModuleType.QUESTIONARIO) {
    if (!to?.path.startsWith('/paciente')) {
      return navigateTo('/paciente')
    }
    return
  }

  // Doctor (médico externo): somente /portal/medico
  if (moduleId === ModuleType.DOCTOR) {
    if (!to?.path.startsWith('/solicitante')) {
      return navigateTo('/solicitante')
    }
    return
  }

  // OTRS: somente /otrs/* e /gerencial/*
  if (moduleId === ModuleType.OTRS) {
    if (!to?.path.startsWith('/otrs')) {
      return navigateTo('/otrs')
    }
    return
  }
})
